module.exports = __webpack_public_path__ + "static/media/rock.69849dd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/login/rock.jpg
// module id = 36
// module chunks = 0